import { VectorPointPlusIcon } from './VectorPointPlusIcon';

/**
 * author: Andrea Antonello
 * id 8722C5FB-0644-4837-B497-D16517B9F08D
 * name vector-point-plus
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point-plus.svg
 * tags
 * - Vector 
 */
export const VectorPointAddIcon = VectorPointPlusIcon;
export default VectorPointAddIcon